class ProductPageBundleAction extends ProductPagePriceUpdater {
  constructor() {
    super();
  }

  static calculateBundleProductDiscount(variant, quantity) {
    let price = variant.price * quantity;
    let comparePrice = variant.compare_at_price ? variant.compare_at_price * quantity : variant.price * quantity;

    if (quantity >= 1 && quantity < window.theme.discountOffers[0][0]) {
      price = variant.price * quantity;
      comparePrice = variant.compare_at_price ? variant.compare_at_price * quantity : variant.price * quantity;
    } else {
      for (let i = 0; i < window.theme.discountOffers.length; i++) {
        let treshold = window.theme.discountOffers[i][0];
        let nextTreshold = 9999;
        
        if ((i + 1) < window.theme.discountOffers.length) {
          nextTreshold = window.theme.discountOffers[i + 1][0];
        }
        
        if (quantity >= treshold && quantity < nextTreshold) {
          let multiplicator = (100 - window.theme.discountOffers[i][1]) / 100;
          price = variant.price * quantity * multiplicator;
          comparePrice = variant.price * quantity;
        }
      }
    }

    return { price: price, comparePrice: comparePrice };
  }

  static calculateBundleStickerDiscount(variant, quantity) {
    let price = variant.price * quantity;
    let comparePrice = variant.compare_at_price ? variant.compare_at_price * quantity : variant.price * quantity;

    if (quantity >= 1 && quantity < window.theme.discountOffers[0][0]) {
      price = variant.price * quantity;
      comparePrice = variant.compare_at_price ? variant.compare_at_price * quantity : variant.price * quantity;
    } else {
      for (let i = 0; i < window.theme.discountOffers.length; i++) {
        let treshold = window.theme.discountOffers[i][0];
        let nextTreshold = 9999;
        
        if ((i + 1) < window.theme.discountOffers.length) {
          nextTreshold = window.theme.discountOffers[i + 1][0];
        }
        
        if (quantity >= treshold && quantity < nextTreshold) {
          let multiplicator = (100 - window.theme.discountOffers[i][1]) / 100;
          price = variant.price * quantity * multiplicator;
          comparePrice = variant.compare_at_price ? variant.compare_at_price * quantity : variant.price * quantity;
        }
      }
    }

    return { price: price, comparePrice: comparePrice };
  }
}
